const state = {
    user: null,
    chips: null,
    token: null,
    eventDetailHideSections: [],
    eventManage:null,
    allmarketsFilter: false,
    isOffer: true
};
const getters = {
    isAuthenticated: state => !!state?.user,
    stateUser: state => state?.user,
    chips: state => state?.chips,
    token: state => state?.token,
    eventDetailHideSections: state => state?.eventDetailHideSections,
    eventManage: state => state?.eventManage,
    allmarketsFilter: state => state?.allmarketsFilter,
    isOffer: state => state?.isOffer,
};
const actions = {
    setUser ({ commit},user) {
        commit('setUser',user);
    },
    setChips({ commit }, chips) {
        commit('setChips', chips);
    },

    setToken({ commit }, token) {
        commit('setToken', token);
    },
    seteventDetailHideSections({ commit }, filter) {
        commit('seteventDetailHideSections', filter);
    },
    setEventManage({ commit }, token) {
        commit('setEventManage', token);
    },
    setallmarketsFilter({ commit }, filter) {
        commit('setallmarketsFilter', filter);
    },
    setIsOffer({ commit }, isOffer) {
        commit('setIsOffer', isOffer);
    },
};
const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setChips(state, chips) {
        state.chips = chips
    },

    setToken(state, token) {
        state.token = token;
    },
    seteventDetailHideSections(state, eventDetailHideSections) {
        state.eventDetailHideSections = eventDetailHideSections;
    },
    setEventManage(state, eventManage) {
        state.eventManage = eventManage;
    },
    setallmarketsFilter(state, filter) {
        state.allmarketsFilter = filter;
    },
    setIsOffer(state, isOffer) {
        state.isOffer = isOffer;
    },
};
export default {
    state,
    getters,
    actions,
    mutations
};